import moment from 'moment'

import { ReportNode } from '@/apollo/graphql'
import { DATE_TIME_FORMAT } from '@/constants'
import { carDisplayLabel } from '@/utils'
import { useApp } from '@/hooks'
import { t } from '@/i18n'

export const useBuildData = (selectedItem?: Partial<ReportNode>) => {
  const { isRTL } = useApp()

  return [
    {
      label: 'report_number',
      value: selectedItem?.reportNumber,
    },
    {
      label: 'car_number',
      value: selectedItem?.carNumber,
    },
    {
      label: 'car',
      value: selectedItem?.car && carDisplayLabel(selectedItem?.car, isRTL),
      link: `/${selectedItem?.customer?.id}/cars/${selectedItem?.car?.id}`,
    },
    {
      label: 'issue_time',
      value: moment(selectedItem?.issueTime).format(DATE_TIME_FORMAT),
    },
    {
      label: 'crime_time',
      value: moment(selectedItem?.crimeTime).format(DATE_TIME_FORMAT),
    },
    {
      label: 'source',
      value: t(selectedItem?.source || ''),
    },
    {
      label: 'location',
      value: selectedItem?.location,
    },
  ]
}
